<template>
  <div class="business-more" v-if="content">
    <div class="business-more-header">
      <img class="logo"
           src="https://a.storyblok.com/f/56057/1462x711/0ea7a3f870/160704_city-aventure-business_logo_rvb-01.png"
           alt="logo city aventure business"/>
      <p v-html="content.more_text"></p>
    </div>
    <ul>
      <li v-for="item in content.items" :key="item._uid">
        <img :src="item.img" :alt="item.title">
        <h3 v-html="item.title"></h3>
        <p v-html="item.text"></p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    },
  };
</script>

<style lang="scss">
  .business-more {
    .business-more-header {
      margin:auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      .logo {
        width: 300px;
        height: auto;
        margin-bottom:1em;
      }
      p {
        font-size:2rem;
        color:$black;
      }
    }
    > ul {
      display: flex;
      justify-content: space-around;
      width:90%;
      margin:2em auto;
      > li {
        flex:1;
        max-width:400px;
        color:$black;
        text-align: center;
        margin: 0 10px;
        img {

        }
        h3 {
          margin:13px 0;
        }
        p {
          font-weight:400;
        }
      }
    }
  }
</style>
